import { EntityLock } from "../../entity/EntityLock";

export class DtoLocksPostRes extends EntityLock {}
